import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { NetworkService } from './core/services/utils/network.service';
import { AuthService } from './core/services/modules/auth.service';
import { SupportWidgetService } from './core/services/utils/support-widget.service';

import { EnvironmentThemeService } from './core/services/modules/environment-theme.service';
import { MenuService } from './core/services/menu/menu.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'analityco';
  private _routerSub?: Subscription;

  constructor(
    private _network: NetworkService,
    private _router: Router,
    private _authService: AuthService,
    private _supportWidget: SupportWidgetService,
    private _themeService: EnvironmentThemeService,
    private _titleService: Title,
    private _menuService: MenuService
  ) {}

  ngOnInit(): void {
    this._themeService.getActiveTheme().subscribe(theme => {
      if (theme && theme.PrimaryColor) {
        const primary = theme.PrimaryColor;
        const secondary = theme.SecondaryColor || (primary.toUpperCase() === '#E45832' ? '#fe8c00' : '#5bb6e4');

        document.documentElement.style.setProperty('--primary-color', primary);
        document.documentElement.style.setProperty('--secondary-color', secondary);
        
        const gradient = `linear-gradient(135deg, ${primary} 0%, ${secondary} 100%)`;
        document.documentElement.style.setProperty('--dynamic-theme-bg', gradient);
      }
    }, err => console.warn('No active theme found or error fetching theme', err));

    this._syncNetworkMonitoring(this._router.url);
    this._syncDocumentTitle(this._router.url);
    this._routerSub = this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this._syncNetworkMonitoring(event.urlAfterRedirects || event.url);
        this._syncDocumentTitle(event.urlAfterRedirects || event.url);
      }
    });

    this._supportWidget.captureClientChannelFromUrl();

    if (this._authService.isAuthenticated()) {
      this._supportWidget.identifyLoggedUser();
    }
  }

  ngOnDestroy(): void {
    if (this._routerSub) {
      this._routerSub.unsubscribe();
    }
  }

  private _syncNetworkMonitoring(url: string): void {
    if (this._isGeocercaTestRoute(url)) {
      this._network.stopMonitoring();
      return;
    }

    this._network.startMonitoring();
  }

  // Título de la pestaña: "Analityco - <módulo>". El widget Angular 21 (<geo-dashboard>)
  // cambia document.title con el título de sus rutas (p.ej. "Empresa Administradora") y
  // nadie lo restablecía al volver a un módulo Angular 9; por eso se fija en CADA
  // navegación del host. Si el widget se monta después, pone su propio título (con el
  // mismo formato) encima de este.
  private _syncDocumentTitle(url: string): void {
    const moduleTitle = this._menuService.getModuleTitleByUrl(url);
    if (!moduleTitle) {
      this._titleService.setTitle('Analityco');
      return;
    }
    const lower = moduleTitle.toLocaleLowerCase('es');
    this._titleService.setTitle(`Analityco - ${lower.charAt(0).toLocaleUpperCase('es')}${lower.slice(1)}`);
  }

  private _isGeocercaTestRoute(url: string): boolean {
    const normalizedUrl = String(url || '');
    return normalizedUrl.includes('geocerca-vnext-test') || normalizedUrl.includes('administrador-2');
  }
}
